<template>
  <div>
    <div>
      <h3 class="title-content">Histórico de Estacionamentos</h3>
      <v-card class="form-card">
        <v-col v-if="vehicles.length > 0">
          <v-row>
            <v-col cols="6">
              <v-select v-model="filter.period" :items="periods" label="Período" item-text="value" return-object @change="search(filter)">
              </v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                  v-model="filter.vehicle"
                  :items="vehicles"
                  item-text="plate"
                  label="Veículo"
                  required
                  return-object
                  @change="search(filter)"
              ></v-select>
            </v-col>
          </v-row>
          <v-layout v-resize="onResize">
            <v-col class="px-0">
              <v-data-table
                  :hide-default-header="isMobile"
                  :headers="headers"
                  :items="rows"
                  :loading="loading"
                  :items-per-page="50"
                  locale="pt-BR"
                  :hide-default-footer="rows.length === 0 || rows.length < 10"
              >
                <template v-slot:item.date_time_begin="{ item }">
                  {{ item.date_time_begin | timeStampToHuman }}
                </template>
                <template v-slot:item.date_time_end="{ item }">
                  {{ item.date_time_end === null ? '---' : timeStampToHuman(item.date_time_end) }}
                </template>
                <template slot="no-data">
                  Nenhum dado encontrado.
                </template>
                <template slot="loading">
                  Carregando
                </template>
              </v-data-table>
            </v-col>
          </v-layout>
        </v-col>
        <div class="message-data text-center" v-show="vehicles.length === 0 && loading === false">
          <i class="far fa-bell"></i>
          <span>Você não possui nenhum veículo cadastrado.</span>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  name: "ActivateOCRHistory",
  data: function () {
    return {
      isMobile: false,
      filter: {
        vehicle: {
          plate: 'Nenhum veículo encontrado.'
        },
        period: null
      },
      vehicles: [],
      periods: [
        {label: 0, value: 'Todo o período'},
        {label: 1, value: 'Hoje'},
        {label: 2, value: 'Os últimos 7 dias'},
        {label: 3, value: 'Esse mês'},
        {label: 4, value: 'Mês anterior'},
        {label: 5, value: 'Esse ano'}
      ],
      loading: false,
      headers: [
        {text: 'Veículo', sortable: false, align: 'center', value: 'plate'},
        {text: 'Endereço', sortable: false, value: 'address'},
        {text: 'Data Entrada', sortable: false, align: 'center', value: 'date_time_begin'},
        {text: 'Data Saída', sortable: false, align: 'center', value: 'date_time_end'},
      ],
      rows: []
    }
  },
  mounted() {
    this.loading = true;
    axios.get('/api/users/driver/me/plate').then(res => {
      res.data.data.forEach(vehicle => {
        if (vehicle.wallet !== null && this.user_id === vehicle.wallet.user_id) {
          this.vehicles.push(vehicle);
        }
      });
      if (this.vehicles.length > 0) {
        this.filter.vehicle = this.vehicles[0];
      }
      this.filter.period = this.periods[0];
      this.search(this.filter);
      this.loading = false;
    });
  },
  methods: {
    timeStampToHuman(value) {
      let data_objeto = moment(value);
      return data_objeto.format('DD/MM/YYYY HH:mm:ss');
    },
    search(filter) {
      var obj = {};
      if (filter.vehicle.plate !== 'Nenhum veículo encontrado.') {
        obj.plate = filter.vehicle.plate;
      } else {
        return true;
      }
      switch (filter.period.label) {
        case 1:
          obj.date_time_begin = moment().format('YYYY-MM-DD 00:00:00');
          obj.date_time_end = moment().format('YYYY-MM-DD 23:59:59');
          break;
        case 2:
          obj.date_time_begin = moment().subtract('7', 'days').format('YYYY-MM-DD 00:00:00');
          obj.date_time_end = moment().format('YYYY-MM-DD 23:59:59');
          break;
        case 3:
          obj.date_time_begin = moment().startOf('month').format('YYYY-MM-DD 00:00:00');
          obj.date_time_end = moment().endOf('month').format('YYYY-MM-DD 23:59:59');
          break;
        case 4:
          obj.date_time_begin = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD 00:00:00');
          obj.date_time_end = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD 23:59:59');
          break;
        case 5:
          obj.date_time_begin = moment().startOf('year').format('YYYY-MM-DD 00:00:00');
          obj.date_time_end = moment().endOf('year').format('YYYY-MM-DD 23:59:59');
          break;
      }
      this.loading = true;
      axios.get('/api/audit/activation', {params: obj}).then(res => {
        this.rows = res.data.data;
        this.loading = false;
      });
    },
    onResize: function () {
      if (window.innerWidth < 769) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    paymentForms(value) {
      if (value == 1) {
        return 'Dinheiro';
      } else if (value == 2) {
        return 'Cartão de Crédito';
      } else if (value == 3) {
        return 'Cartão de Débito';
      } else if (value == 4) {
        return 'Carteira';
      } else if (value == 5) {
        return 'Boleto';
      }
    }
  },
  computed: {
    advancedWalletOptions: function () {
      return process.env.VUE_APP_ADVANCED_WALLET_OPTIONS;
    },
    user_id: function () {
      return JSON.parse(localStorage.getItem('user')).id;
    },
    showWallets() {
      return process.env.VUE_APP_SHOW_WALLETS;
    }
  },
}
</script>

<style scoped>

</style>
